// extracted by mini-css-extract-plugin
export default {"perks":"perks-rdkqYWMM","perk":"perk-h4Djrq6t","perkIcon":"perkIcon-GLu_pLkk","perkIconImage":"perkIconImage-uJRTEeDD","body":"body-bo0DP7Oy"};